import HomeSection from "./HomeSection";
import HomeRating from "./HomeRating";

const HOME_BG_IMAGE_PATH = "/homePage-bg-img/homePage-bg-img.svg";

export default function HomeHeroSection() {
	return (
		<>
			<div className="home-bg-image">
				<HomeSection />
				<HomeRating />
			</div>

			<style jsx>{`
				.home-bg-image {
					background-image: url(${HOME_BG_IMAGE_PATH});
					background-size: cover;
					background-position: center;
				}
			`}</style>
		</>
	);
}
